var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertTriangle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 17.2026V11.2219M16 21.6356V21.6882M23.5599 26.6693H8.44009C6.3748 26.6693 4.6319 25.3043 4.08354 23.4369C3.84946 22.6397 4.13708 21.8094 4.57701 21.1024L12.1369 7.47064C13.9081 4.62437 18.0919 4.62437 19.8631 7.47064L27.423 21.1024C27.8629 21.8094 28.1505 22.6397 27.9165 23.4369C27.3681 25.3043 25.6252 26.6693 23.5599 26.6693Z",
  stroke: "#E28721",
  strokeWidth: 2.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertTriangle);
export default ForwardRef;